import { render, staticRenderFns } from "./PreviewBanner.vue?vue&type=template&id=66db5862"
import script from "./PreviewBanner.vue?vue&type=script&lang=js"
export * from "./PreviewBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports